import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import Constants from '../../../definitions/constants';
import InterfaceTooling from '../../../tooling/interfaceTooling';

import GlassPopup from '../common/interface/glassPopup';
import ErrorFeedback from '../common/feedback/errorFeedback';
import Select from '../common/inputs/select';
import FieldInfo from '../common/inputs/fieldInfo';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import HoverTooltip from '../common/interface/hoverTooltip';

const ErrorDetailPopup = props => {
  const {
    handleShowPopup,
    errors,
    handleCalculationDetailPopup,
    groupErrorDescription,
    errorNotificationCode,
    popupState,
  } = props;
  return (
    <GlassPopup
      className="form_popup error_detail_popup"
      title={(<FormattedMessage id="notifications.errorDetailPopup.title"/>)}
      {...props}
    >
      <p className="form_paragraph">
        <FormattedMessage
          id="notifications.errorDetailPopup.subtitle"
          values={{errorAmount: errors.length}}
        />
        {" '"+groupErrorDescription+"'"}
      </p>
      {errorNotificationCode==Constants.notifications.METRIC_IMPORT_TYPE ? (
        <ErrorFeedback
          status={402}
          fieldErrors={{errors: 
            [<span><b>
              {groupErrorDescription}
            </b></span>].concat(
            errors.map(item => {
              return (
              <React.Fragment>
                <span style={{paddingLeft: "15px"}}>
                  {item.message}
                </span>
                {item.rows && (
                  <HoverTooltip
                    toolTip={intl.formatMessage({id: "notifications.errorDetailPopup.linesLabel"}) + " " + item.rows}
                    // toolTipType={Constants.interface.toolTip.formulaDraggable} //currently uses default tooltip type
                    placement="right" 
                    enterDelay={300} 
                    leaveDelay={100}
                  >
                    <i className="error_rows_detail_tooltip_icon fas fa-question-circle"/>
                  </HoverTooltip>
                )}
              </React.Fragment>
              );
            }))
          }}
        />
        ) : (
        <ErrorFeedback
          status={402}
          fieldErrors={{errors: errors.map(item => {
            return (
              <span 
                onClick={handleCalculationDetailPopup}
                data-calculationid={item.root_calculation_instance_id}
                className={"error_notification_link"}
              >
                {item.message}
              </span>
            );
          })}}
        />
        )
      }
    </GlassPopup>
  );
};

export default ErrorDetailPopup;



// WEBPACK FOOTER //
// ./source/client/components/dashboard/errorDetailPopup.jsx